<template>
  <div class="department-list" :style="{height: height}" v-loading="loading">
    <el-tree
      :props="treeProps"
      node-key="id"
      :load="getDepartmentList"
      lazy
      @node-click="nodeClick"
    />
  </div>
</template>

<script>
import http from "@/components/Admin/Flow/common/Http";
import _ from "lodash";
export default {
  name: "hr-department-tree",
  data() {
    return {
      loading: false,
      treeData: [],
      treeProps: { label: "department_name" },
    };
  },
  props:{
    height:{
      type:String,
      default() {
        return "calc( 100vh - 220px )";
      }
    }
  },
  methods:{
    getDepartmentList(node, resolve) {
      setTimeout(() => {
        let parent_id = 0;
        if (node.data != undefined) {
          parent_id = node.data.id;
        }
        if (parent_id == 0) this.loading = true;
        http.get("hrm/department/list", { parent_id: parent_id }, (res) => {
          let listData;
          listData = res.data.map((item) => {
            return {
              department_name: item.department_name,
              id: item.id,
            };
          });
          return resolve(listData);
        });
        this.loading = false;
      }, 300);
    },
    nodeClick(data) {
      this.$emit("node-click", data);
    },
  }
}
</script>

<style lang="scss" scoped>
.department-list {
  overflow-y: scroll;
  //height: calc( 100vh - 120px );
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/Admin/Common/hr-department-tree.vue